import Cookies from "js-cookie";

const COOKIE_CONFIG = {
  secure: process.env.NODE_ENV === "production",
  sameSite: "strict" as const,
  expires: 7,
  path: "/",
};

export const TOKEN_COOKIE = "auth_token";
export const REFRESH_TOKEN_COOKIE = "refresh_token";
export const REMEMBER_EMAIL_COOKIE = "remember_email";
export const REMEMBER_PASSWORD_COOKIE = "remember_password";

export const setAuthCookies = (authToken: string, refreshToken?: string) => {
  Cookies.set(TOKEN_COOKIE, authToken, COOKIE_CONFIG);
  if (refreshToken) {
    Cookies.set(REFRESH_TOKEN_COOKIE, refreshToken, COOKIE_CONFIG);
  }
};

export const getAuthToken = () => {
  return Cookies.get(TOKEN_COOKIE);
};

export const getRefreshToken = () => {
  return Cookies.get(REFRESH_TOKEN_COOKIE);
};

export const removeAuthCookies = () => {
  Cookies.remove(TOKEN_COOKIE);
  Cookies.remove(REFRESH_TOKEN_COOKIE);
};

export const setRememberMeCookies = (email: string, password: string) => {
  Cookies.set(REMEMBER_EMAIL_COOKIE, btoa(email), COOKIE_CONFIG);
  Cookies.set(REMEMBER_PASSWORD_COOKIE, btoa(password), COOKIE_CONFIG);
};

export const getRememberMeCookies = () => {
  const email = Cookies.get(REMEMBER_EMAIL_COOKIE);
  const password = Cookies.get(REMEMBER_PASSWORD_COOKIE);
  return email && password ? { email: atob(email), password: atob(password) } : null;
};

export const removeRememberMeCookies = () => {
  Cookies.remove(REMEMBER_EMAIL_COOKIE);
  Cookies.remove(REMEMBER_PASSWORD_COOKIE);
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};
